import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";

// Casting is closed — the debut cast has been selected. This page replaces
// the multi-step form so any stale share links still land somewhere on-brand.
export default function Apply() {
    return (
        <main data-testid="apply-page" className="pt-40 pb-32 min-h-screen relative overflow-hidden">
            <div
                aria-hidden
                className="absolute inset-0 opacity-[0.05] pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 20% 20%, var(--gold), transparent 40%), radial-gradient(circle at 80% 70%, var(--wine), transparent 45%)",
                }}
            />
            <section className="relative mx-auto max-w-4xl px-6 lg:px-12 text-center" data-testid="casting-closed">
                <p className="eyebrow" data-testid="casting-closed-eyebrow">Casting is now closed</p>
                <h1
                    className="font-display mt-8 leading-[0.92]"
                    style={{ fontSize: "clamp(3rem, 8vw, 7rem)" }}
                    data-testid="casting-closed-headline"
                >
                    The cast is<br />
                    <em className="text-[color:var(--gold)]">finalized</em>.
                </h1>
                <p className="mt-8 max-w-2xl mx-auto text-[color:var(--cream-muted)] text-lg leading-relaxed">
                    Our debut cast has been selected, the house is secured, and we're preparing to begin filming this October. Thank you to every woman who applied and shared her story with us — over 200 of you did.
                </p>

                <div className="mt-16 grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto text-left" data-testid="casting-closed-stats">
                    {[
                        { n: "200+", t: "Women applied", d: "From across the country." },
                        { n: "35+", t: "Second-round callbacks", d: "Reviewed by the casting team." },
                        { n: "14", t: "Final housemates selected", d: "Married, dating, and single." },
                        { n: "Oct.", t: "Filming begins", d: "Inside the house we secured for Chapter One." },
                    ].map((s, i) => (
                        <div key={s.t} className="border border-[color:var(--espresso)] p-6 bg-[color:var(--dark-grey)]/40" data-testid={`casting-closed-stat-${i}`}>
                            <span className="font-display text-4xl md:text-5xl text-[color:var(--gold)] leading-none">{s.n}</span>
                            <p className="mt-3 font-serif text-lg text-[color:var(--soft-cream)]">{s.t}</p>
                            <p className="mt-1 text-sm text-[color:var(--cream-muted)]">{s.d}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-16 mx-auto max-w-xl border border-[color:var(--gold)]/40 bg-[color:var(--gold)]/5 px-6 py-6 text-left" data-testid="casting-closed-nextsteps">
                    <p className="text-[0.68rem] uppercase tracking-[0.28em] text-[color:var(--gold)]">What's next</p>
                    <p className="mt-3 text-[color:var(--soft-cream)] leading-relaxed">
                        A pre-filming mixer with the final cast in Atlanta is being planned within the next three weeks. Stay tuned — follow the trailer and letters from the table for release news, behind-the-scenes moments, and future casting announcements.
                    </p>
                </div>

                <div className="mt-14 flex flex-wrap items-center justify-center gap-4">
                    <Link to="/original-series#trailer" className="btn-gold btn-gold-solid" data-testid="casting-closed-watch-trailer">
                        <Play size={14} strokeWidth={1.5} /> Watch the trailer
                    </Link>
                    <Link to="/original-series" className="btn-gold" data-testid="casting-closed-learn-more">
                        About the series <ArrowRight size={14} strokeWidth={1.5} />
                    </Link>
                    <a href="/#letters-from-the-table" className="btn-gold" data-testid="casting-closed-notify">
                        Get release updates
                    </a>
                </div>
            </section>
        </main>
    );
}
